
import React from "react";
import { Classname } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { ITeamWebsite, ITournamentEditionMatch } from "../../../../../services";
import { matchParticipants, matchScores, participantImage, participantName } from "./match";

export interface MatchCardProps {
    publicId: string;
    website: ITeamWebsite;
    match: ITournamentEditionMatch;
}

function MatchCard({ publicId, match: t }: MatchCardProps) {

    const labels = i18nManager.Labels.match;
    const scores = matchScores(t);
    const participants = matchParticipants(t).slice(0, 2);
    const isLive = t.status === "ONGOING";

    return (<a className={styles["match-card"]} target="_blank" rel="noreferrer" href={Utils.buildTournamentMatchLink(publicId, t)}>
        <div className={styles["match-card-meta"]}>
            <span className={Classname.build(styles["match-card-date"], { [styles["is-live"]]: isLive })}>
                {isLive ? (<><i className="fa fa-circle" style={{ fontSize: "0.55em", verticalAlign: "middle" }} /> {labels.live}</>) : Utils.fineDate(new Date(t.start_date))}
            </span>
            {t.tournament_edition?.logo_url && (<img className={styles["match-card-comp-logo"]} src={t.tournament_edition.logo_url} alt="" />)}
        </div>
        <h3 className={styles["h4"]}>{t.tournament_edition?.name}</h3>
        <div className={styles["match-card-teams"]}>
            {participants.map((p, i) => (<div key={p.external_id + i} className={styles["match-card-team"]}>
                {participantImage(p) ? (<img src={participantImage(p)} alt="" />) : (<span className={styles["match-card-ph"]} />)}
                <span className={styles["match-card-name"]}>{participantName(p)}</span>
                {(t.status !== "UPCOMING" && scores?.[i] !== undefined) && (<span className={styles["match-card-score"]}>{scores[i]}</span>)}
            </div>))}
        </div>
    </a>);
}

export default MatchCard;
